// extracted by mini-css-extract-plugin
module.exports = {"main":"Marquee_main__94IQA","inner":"Marquee_inner__3pb2B","text":"Marquee_text__8HJW9","marquee":"Marquee_marquee__wTFVO","error":"Marquee_error__-XySY"};